module.exports = __webpack_public_path__ + "img/send-email.b0102e94.svg";